import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { landingPathForRole } from '../../lib/roleRouting';

/**
 * `/espaces` : l'ancien écran de choix entre « Planning & Comptabilité » et
 * « Gestion CDV ». Aucun lien n'y menait plus, et le tableau de bord général
 * `/admin` le remplace : l'adresse renvoie chacun vers sa page d'arrivée.
 * Elle reste sous `StaffRoute`, qui attend que le rôle soit connu.
 */
export default function RedirectionParRole() {
  const { user, profile } = useAuthStore();
  const role = (user?.app_metadata?.role as string) || profile?.role;
  return <Navigate to={landingPathForRole(role)} replace />;
}
